import { useQueryParam } from './useQueryParam';

export const useEmailQueryParam = () => {
  const encodedEmail = useQueryParam('email');
  const email = decodeURIComponent(encodedEmail);
  return email;
};
